import { Alert, type AlertProps, Stack } from "@mantine/core";
import { IconCircleCheck } from "@tabler/icons-react";
import type { ReactElement } from "react";
import { AlertPresets } from "../../../../mantine/mantinePresets";
import { THEME_VARS } from "../../../../utils/constants";
import type { GuaranteeOfOriginCheckResponse } from "../../GuaranteeOfOrigin.types";
import "./GuaranteeOfOriginCheckResult.scss";

export interface GuaranteeOfOriginCheckResultProps {
  result: Array<GuaranteeOfOriginCheckResponse>;
}
export function GuaranteeOfOriginCheckResult({
  result
}: GuaranteeOfOriginCheckResultProps) {
  const alerts: Array<ReactElement<AlertProps>> = [];

  if (result.some((value) => !value.isOnboardingComplete)) {
    alerts.push(
      <Alert
        color={AlertPresets.warning.color}
        icon={AlertPresets.warning.icon}
        key="onboarding"
      >
        Bitte schließen Sie den Onboarding-Prozess ab. Erst dann können wir die
        Dokumentation für Ihre Herkunftsnachweise generieren.
      </Alert>
    );
  } else {
    if (result.some((value) => !value.isEnergyDataComplete)) {
      alerts.push(
        <Alert
          color={AlertPresets.warning.color}
          icon={AlertPresets.warning.icon}
          key="energy-data"
        >
          Leider liegen die Energiedaten für den ausgewählten Zeitraum nicht
          vollständig vor. Sie können eine Dokumentation nur für die
          vorliegenden Daten erstellen oder die fehlenden Energiedaten ergänzen.
        </Alert>
      );
    }
    if (result.some((value) => !value.isMbkConfigurationCorrect)) {
      alerts.push(
        <Alert
          color={AlertPresets.warning.color}
          icon={AlertPresets.warning.icon}
          key="mbk-configuration"
        >
          Die Berechnungsformeln der Liegenschaft sind veraltet und unterstützen
          keine zeitliche Anpassungen. Bitte stellen Sie sicher, dass alle
          Mengenangaben in Ihrer Dokumentation größer als 0 sind. Aktualisieren
          Sie die Formeln, um eine korrekte Mengenermittlung zu gewährleisten.
        </Alert>
      );
    }
    if (result.some((value) => !value.isConnectionDataSufficient)) {
      alerts.push(
        <Alert
          color={AlertPresets.warning.color}
          icon={AlertPresets.warning.icon}
          key="connection-data"
        >
          Es fehlen Informationen am Netzverknüpfungspunkt. Bitte stellen Sie
          sicher, dass die Art der Versorgung und das Messkonzept hinterlegt
          sind.
        </Alert>
      );
    }
  }

  if (alerts.length > 0) {
    return <Stack>{alerts}</Stack>;
  }

  return (
    <Stack align="center" className="GuaranteeOfOriginCheckResult">
      <IconCircleCheck color={THEME_VARS.primary[6]} size={30} />
      <div>
        Ihre Daten liegen vollständig vor! Die Dokumentation für Ihre
        Herkunftsnachweise kann jetzt erstellt werden. Klicken Sie dazu auf den
        Button <i>Dokument erstellen</i>.
      </div>
    </Stack>
  );
}
